import { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';

// Paged info dialog for the Tools screens — replaces raw notes dumped at the
// bottom of each tool. `pages` = [{ title?, body }] (body = string | JSX); one
// page renders as a plain dialog, multiple pages get ‹ › navigation.
export default function InfoNotes({ open, onClose, title, pages = [] }) {
  const [i, setI] = useState(0);
  useEffect(() => { if (open) setI(0); }, [open]);
  const page = pages[i] || {};
  const many = pages.length > 1;

  return (
    <Modal open={open} onCancel={onClose} footer={null} centered title={page.title ? `${title} — ${page.title}` : title} destroyOnHidden>
      <div style={{ fontSize: 13, lineHeight: 1.65, whiteSpace: 'pre-line', minHeight: many ? 180 : undefined }}>
        {page.body}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 16 }}>
        {many && (
          <>
            <Button size="small" disabled={i === 0} onClick={() => setI(i - 1)} style={{ width: 34, padding: 0 }}>‹</Button>
            <span style={{ fontSize: 11.5, color: 'var(--muted)', minWidth: 34, textAlign: 'center' }}>{i + 1} / {pages.length}</span>
            <Button size="small" disabled={i === pages.length - 1} onClick={() => setI(i + 1)} style={{ width: 34, padding: 0 }}>›</Button>
          </>
        )}
        <div style={{ flex: 1 }} />
        <Button type="primary" size="small" onClick={onClose}>OK</Button>
      </div>
    </Modal>
  );
}
